<template>
  <v-card class="item" flat tile>
    <img
      @error="imgError"
      class="d-block item-img"
      :src="files + img + '?resize=1&w=300'"
      :alt="title"
      width="100%"
    />

    <div class="px-3 px-md-4">
      <div
        class="
          primary--text
          text-body-1 text-md-h6 text-center
          font-weight-medium
          pt-2 pt-sm-3
        "
      >
        {{ title }}
      </div>

      <div
        v-if="position"
        class="
          grey--text
          text-body-2 text-body-1 text-center
          font-weight-bold
          pt-1
          pb-2
        "
      >
        {{ position }}
      </div>
      <p class="text-body-2 grey-text text-center">{{ text }}</p>
    </div>
  </v-card>
</template>

<script>
import DefaultImg from "../../assets/img/default-img.png";

export default {
  props: {
    img: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "",
    },
  },
  methods: {
    imgError(e) {
      e.target.src = DefaultImg;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 3 / 4;
    object-fit: cover;
  }
}
</style>
